import genresActionType from "./genres.type";
import { deleteGenre } from "./genres.utils";

const INITIAL_STATE = {
  allGenres: [],
  virtualGenres: [],
  isLoading: false,
};

const genresReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case genresActionType.FETCH_GENRE_START:
    case genresActionType.ADD_GENRE_START:
    case genresActionType.DELETE_GENRE_START:
      return {
        ...state,
        isLoading: true,
      };
    case genresActionType.FETCH_GENRE_SUCCESS:
      return {
        ...state,
        allGenres: action.payload,
        virtualGenres: action.payload,
        isLoading: false,
      };
    case genresActionType.DELETE_GENRE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        allGenres: deleteGenre(state.allGenres, action.payload),
      };
    case genresActionType.FETCH_GENRE_FAILURE:
    case genresActionType.ADD_GENRE_SUCCESS:
    case genresActionType.ADD_GENRE_FAILURE:
    case genresActionType.DELETE_GENRE_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
};

export default genresReducer;
